/**
 * Limbo math — standalone leaf module. Call a target multiplier, the server rolls
 * the SAME provably-fair curve as crash (deriveCrashFromR); you win if the roll
 * meets your target. One shot, no mid-round decisions — so unlike mines there is
 * zero state and zero probe surface.
 *
 * Score = the TARGET you called (×100), not the roll — bragging rights go to the
 * nerve, not the dice.
 */
import { deriveCrashFromR } from "./crash.js";

export const LIMBO_MIN_TARGET = 1.01;
export const LIMBO_MAX_TARGET = 1000;
/** Leaderboard bounds, ×100. */
export const LIMBO_MIN = 101;
export const LIMBO_MAX = 100_000;

/** Win chance for a target under the 1%-edge curve: P(roll ≥ t) = 0.99/t. */
export function limboWinChance(target: number): number {
  return Math.min(0.99 / target, 1);
}

/** Roll from a uniform r ∈ [0,1) — exactly the crash curve. */
export function limboRoll(r: number): number {
  return deriveCrashFromR(r);
}

export function isValidTarget(t: number): boolean {
  return (
    Number.isFinite(t) &&
    t >= LIMBO_MIN_TARGET &&
    t <= LIMBO_MAX_TARGET &&
    // ×100 must be integral — targets are picked in cents of x (1.01, 2.50, …)
    Math.abs(t * 100 - Math.round(t * 100)) < 1e-6
  );
}

export function limboToScoreValue(target: number): number {
  return Math.min(Math.max(Math.round(target * 100), LIMBO_MIN), LIMBO_MAX);
}
